import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Card, PageHeader, Button, Row, Col } from "antd";
import Filters, { FilterItem, Types } from "../../components/Filters";
import IntegrationList from "../../components/IntegrationList";
import {
  IntegrationForm,
  IntegrationRegisterForm,
} from "../../components/Forms";
import { SpecieProvider } from "../../context/SpecieContext";
import {
  IntegrationProvider,
  IntegrationConsumer,
} from "../../context/IntegrationContext";
import { ShelterConsumer, ShelterProvider } from "../../context/ShelterContext";
import { PartnerKeyTypeArray } from "../../interfaces/IIntegration";
import debounce from "lodash.debounce";

export default class Integration extends Component {
  private integrationFilterDispatchOptions = {
    search: {
      deleted: false,
      active: true,
      shelter: {
        with: {
          deleted: false,
        },
      },
      branch: {
        with: {
          deleted: false,
        },
      },
      // integration_syncs: {
      //   with: {
      //     _orderBy: [
      //       {
      //         column: "id",
      //         sort: "DESC",
      //       },
      //     ],
      //     _limit: 1,
      //     deleted: false,
      //   },
      // },
    },
    options: {
      // sort: ["-last_sync"],
      _force_ids: true,
    },
  } as const;

  integrationListSearch = Object.assign(
    {},
    this.integrationFilterDispatchOptions
  );

  handleFiltersSubmit = (payload: any) => {
    if (payload && payload.search) {
      this.integrationListSearch = {
        ...this.integrationListSearch,
        search: payload.search,
      };
    }
  };

  renderAdd = () => {
    const { permissions }: any = this.props;
    if (!permissions.create) return null;

    return (
      <Link to="integration/add">
        <Button type="primary" shape="round">
          Create new integration
        </Button>
      </Link>
    );
  };

  render() {
    const {
      permissions,
      history,
      goBack,
      match: {
        params: { integrationUuid },
      },
    }: any = this.props;

    return (
      <IntegrationProvider>
        <SpecieProvider>
          <ShelterProvider>
            <ShelterConsumer>
              {({ shelters, requestShelterList }) => (
                <IntegrationConsumer>
                  {({
                    fetching,
                    error,
                    integrations,
                    integration,
                    authUuid,
                    settings,
                    total,
                    sync,
                    syncSections,
                    pagination,

                    requestIntegrationList,
                    requestIntegrationFind,
                    requestPartnerAuth,
                    requestVerifySettings,
                    requestVerifySync,
                    requestVerifySyncSections,
                    requestRetrieveTotalPet,
                    requestSyncOne,
                    requestSyncAbort,
                    requestUpdateSettings,
                    requestUpdateSyncSections,
                    requestConnect,
                    requestDisconnect,
                    requestSetMain,
                  }) => {
                    // Shelter filters

                    const loadSheltersDispatch = (args: any = {}) =>
                      requestShelterList({
                        search: {
                          ...args,
                          organization_branches: {
                            with: true,
                          },
                        },
                        options: {
                          limit:-1,
                          sort: ["-organization_branches.name"],
                          _force_ids: true,
                        },
                      });

                    const delayedSearch = debounce((v) => {
                      if (v) {
                        loadSheltersDispatch({ name: { ilike: `%${v}%` } });
                      }
                    }, 500);

                    const sheltersToFilter = shelters?.map((v) => {
                      return {
                        value: v.id,
                        text: v.name,
                      };
                    });

                    const partnerToFilter = PartnerKeyTypeArray.map((v) => {
                      return {
                        value: v,
                        text: v,
                      };
                    });

                    // Edit integration
                    if (integrationUuid) {
                      if (integrationUuid === "add") {
                        return (
                          <Card>
                            <PageHeader
                              title={"New Integration"}
                              onBack={() => goBack("/integration")}
                            >
                              <IntegrationRegisterForm
                                authUuid={authUuid}
                                integration={integration}
                                settings={settings}
                                total={total}
                                error={error}
                                loading={fetching || false}
                                history={history}
                                verifySettings={requestVerifySettings}
                                updateSettings={requestUpdateSettings}
                                retrieveTotalPet={requestRetrieveTotalPet}
                                authPartner={requestPartnerAuth}
                                makeConnection={requestConnect}
                              />
                            </PageHeader>
                          </Card>
                        );
                      }

                      let addon: any = {
                        integrationUuid: integrationUuid,
                        permissions: permissions,
                      };

                      return (
                        <Card>
                          <PageHeader
                            title={
                              integration
                                ? `Integration - ${integration?.shelter?.name}/${integration?.branch?.name ?? "-"}`
                                : "Loading"
                            }
                            onBack={() => goBack("/integration")}
                          >
                            <IntegrationForm
                              {...addon}
                              integration={integration}
                              settings={settings}
                              total={total}
                              sync={sync}
                              syncSections={syncSections}
                              loading={fetching}
                              error={error}
                              history={history}
                              loadIntegration={requestIntegrationFind}
                              verifySettings={requestVerifySettings}
                              verifySync={requestVerifySync}
                              verifySyncSections={requestVerifySyncSections}
                              retrieveTotalPet={requestRetrieveTotalPet}
                              syncOne={requestSyncOne}
                              syncAbort={requestSyncAbort}
                              updateSettings={requestUpdateSettings}
                              updateSyncSections={requestUpdateSyncSections}
                            />
                          </PageHeader>
                        </Card>
                      );
                    }

                    return (
                      <>
                        <Card title="Filters" style={{ marginBottom: 25 }}>
                          <Filters
                            size="medium"
                            loading={fetching}
                            history={history}
                            defaultSubmitOptions={
                              this.integrationFilterDispatchOptions
                            }
                            dispatches={[loadSheltersDispatch]}
                            submitDispatch={requestIntegrationList}
                            onSubmit={this.handleFiltersSubmit}
                          >
                            {({ values, handleFilterChange }: any) => (
                              <Row gutter={9} style={{ width: "100%" }}>
                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="uuid"
                                    type={Types.INPUT}
                                    placeholder="Integration UUID"
                                    value={values["uuid"]}
                                    size="medium"
                                    options={{
                                      input: {
                                        allowClear: true,
                                      },
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>

                                {console.log(values)}

                                <Col xs={24} md={9}>
                                  <FilterItem
                                    name="shelter_id"
                                    type={Types.SELECT}
                                    placeholder="Shelter"
                                    data={sheltersToFilter}
                                    value={values["shelter_id"]}
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true,
                                        onDropdownVisibleChange: (open) => {
                                          if (open) {
                                            loadSheltersDispatch();
                                          }
                                        },
                                        onSearch: async (v) => {
                                          delayedSearch(v);
                                        },
                                      },
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>

                                <Col xs={24} md={6}>
                                  <FilterItem
                                    name="partner_key"
                                    type={Types.SELECT}
                                    placeholder="Integration type"
                                    data={partnerToFilter}
                                    value={values["partner_key"]}
                                    size="medium"
                                    options={{
                                      select: {
                                        allowClear: true,
                                        showSearch: true,
                                      },
                                    }}
                                    onChange={handleFilterChange}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Filters>
                        </Card>

                        <Card
                          title="List of Integrations"
                          extra={this.renderAdd()}
                        >
                          <IntegrationList
                            loading={fetching}
                            integrations={integrations}
                            pagination={pagination}
                            permissions={permissions}
                            history={history}
                            searchOptions={this.integrationListSearch}
                            loadIntegrations={requestIntegrationList}
                            disconnectIntegration={requestDisconnect}
                            setMainIntegration={requestSetMain}
                          />
                        </Card>
                      </>
                    );
                  }}
                </IntegrationConsumer>
              )}
            </ShelterConsumer>
          </ShelterProvider>
        </SpecieProvider>
      </IntegrationProvider>
    );
  }
}
